let fammiqueCartItems = [];
let fammiqueCartRenderTimer;

function fammiqueGetProperty(item, key) {
    if (!item || !item.properties) return '';
    if (Array.isArray(item.properties)) {
        const property = item.properties.find((entry) => entry && entry[0] === key);
        return property ? property[1] : '';
    }
    return item.properties[key] || '';
}

function fammiqueGetVariantId(item) {
    return Number(item?.variant_id || item?.id || item?.variant?.id) || null;
}

function fammiqueGetMetafieldDeliveryLabel(item) {
    const variantId = fammiqueGetVariantId(item);
    if (!variantId) return '';

    return window.fammiqueCartVariantDeliveryLabels?.[variantId] || '';
}

function fammiqueGetDeliveryLabel(item) {
    const metafieldDeliveryLabel =
        fammiqueGetProperty(item, '_delivery_frequency') ||
        fammiqueGetMetafieldDeliveryLabel(item);

    if (metafieldDeliveryLabel) return metafieldDeliveryLabel;

    const sellingPlanName =
        item?.selling_plan_allocation?.selling_plan?.name ||
        item?.selling_plan_allocation?.name ||
        item?.selling_plan_name ||
        item?.selling_plan ||
        fammiqueGetProperty(item, 'Delivery frequency') ||
        fammiqueGetProperty(item, 'Lieferfrequenz');

    if (sellingPlanName) return sellingPlanName;
    return '';
}

function fammiqueGetVariantIdFromRow(row) {
    const variantLink = row?.querySelector('a[href*="variant="]');
    if (!variantLink) return null;

    try {
        const url = new URL(variantLink.getAttribute('href'), window.location.origin);
        return parseInt(url.searchParams.get('variant'), 10) || null;
    } catch (error) {
        const match = variantLink.getAttribute('href').match(/variant=(\d+)/);
        return match ? parseInt(match[1], 10) : null;
    }
}

function fammiqueFindCartItem(row, rowIndex) {
    const variantId = fammiqueGetVariantIdFromRow(row);
    const bundleId = row?.getAttribute('data-fammique-bundle-id');
    const items = fammiqueCartItems.length ? fammiqueCartItems : (window.unicornCartData?.items || []);

    if (variantId) {
        const matchedByVariant = items.find((item) => fammiqueGetVariantId(item) === variantId);
        if (matchedByVariant) return matchedByVariant;
    }

    if (bundleId) {
        const matchedByBundle = items.find((item) => String(fammiqueGetProperty(item, '_bundle_id')) === bundleId);
        if (matchedByBundle) return matchedByBundle;
    }

    return items[rowIndex] || null;
}

function fammiqueFindUnicornTitleLink(row) {
    const links = Array.from(row.querySelectorAll('a'));
    return links.find((link) => link.textContent.trim().length > 0) || null;
}

function fammiqueRenderUnicornCartDetails() {
    const rows = Array.from(document.querySelectorAll('.unicorn_cart_item'));
    if (!rows.length) return;

    rows.forEach((row, index) => {
        const item = fammiqueFindCartItem(row, index);
        if (!item || fammiqueGetProperty(item, '__smart_discount_flow_properties') === '__free') return;

        const titleLink = fammiqueFindUnicornTitleLink(row);
        if (!titleLink) return;

        const variantTitle = item.variant_title || item.variant?.title || '';
        const cleanVariantTitle = variantTitle && variantTitle !== 'Default Title' ? variantTitle : '';
        const deliveryLabel = fammiqueGetDeliveryLabel(item);

        const nextDetails = [cleanVariantTitle, deliveryLabel].filter(Boolean);
        let details = titleLink.parentElement.querySelector('.fammique-unicorn-cart-details');

        if (!nextDetails.length) {
            if (details) details.remove();
            return;
        }

        if (
            details &&
            details.getAttribute('data-variant-title') === cleanVariantTitle &&
            details.getAttribute('data-delivery-label') === deliveryLabel
        ) {
            return;
        }

        if (!details) {
            details = document.createElement('div');
            details.className = 'fammique-unicorn-cart-details';
            titleLink.insertAdjacentElement('afterend', details);
        }

        details.setAttribute('data-variant-title', cleanVariantTitle);
        details.setAttribute('data-delivery-label', deliveryLabel);
        details.innerHTML = '';

        if (cleanVariantTitle) {
            const variant = document.createElement('span');
            variant.className = 'fammique-unicorn-cart-variant';
            variant.textContent = cleanVariantTitle;
            details.appendChild(variant);
        }

        if (deliveryLabel) {
            const delivery = document.createElement('span');
            delivery.className = 'fammique-unicorn-cart-delivery';
            delivery.textContent = deliveryLabel;
            details.appendChild(delivery);
        }
    });
}

function fammiqueRefreshCartDetails() {
    clearTimeout(fammiqueCartRenderTimer);
    fammiqueCartRenderTimer = setTimeout(() => {
        fetch('/cart.js')
            .then((response) => response.json())
            .then((cart) => {
                fammiqueCartItems = cart.items || [];
                fammiqueRenderUnicornCartDetails();
            })
            .catch(() => {
                fammiqueCartItems = window.unicornCartData?.items || [];
                fammiqueRenderUnicornCartDetails();
            });
    }, 150);
}

document.addEventListener('DOMContentLoaded', function () {
    fammiqueRefreshCartDetails();

    const observer = new MutationObserver(() => fammiqueRefreshCartDetails());
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
});


$('.newaddtocart').click(function (e) {
    e.preventDefault()
    e.stopPropagation()
    let data = [];
    let var_id = $('.product-form__input--pill input[type=radio]:checked').attr('var-id')
    let title = $('.product-form__input--pill input[type=radio]:checked').val()
    let variant_title = parseInt(title.split( )[0])
    let qty = parseInt($('.quantity__input').val()) || 1;
    let isSubscription = $('.pvo-input-container.active');
    let selling_id = $('.product-form__input--pill input[type="radio"]:checked + label')
    const bundleId = Math.floor(1000 + Math.random() * 9000);
    const product = (isSubscription.length == 0 ? withOut_subs : with_subs).find(item => item.variant_id == parseInt(var_id));
    product.free_variant_ids.forEach(id => {
        data.push({
            id: id.toString(),
            quantity: 1,
            properties: {
            _bundle_id: bundleId,
            __smart_discount_flow_properties: '__free'
            }
        });
    });

     const mainProductProperties = {_bundle_id: bundleId};
    if (isSubscription.length > 0 && product.delivery_frequency) {
        mainProductProperties._delivery_frequency = product.delivery_frequency;
    }

    data.push({
        id: var_id,
        quantity: qty,
        properties: mainProductProperties,
        ...(isSubscription.length > 0
        ? { selling_plan: (selling_id?.attr('data-selling')?.toString()) }
        : {})
    });
    console.log(data, 'final items');
    //return
    $.ajax({
    method: "POST",
    url: "/cart/add.js",
    dataType: "json",
    data: { items: data },
    success: function (cart) {
        fetch(`${routes.cart_url}?sections=cart-drawer`)
            .then((response) => response.json())
            .then((sections) => {
            const sectionIds = ['cart-drawer'];
            for (const sectionId of sectionIds) {
                const htmlString = sections[sectionId];
                const html = new DOMParser().parseFromString(htmlString, 'text/html');
                const sourceElement = html.querySelector(`${sectionId}`);
                const targetElement = document.querySelector(`${sectionId}`);
                if (targetElement && sourceElement) {
                targetElement.replaceWith(sourceElement);
                }
            }
            document.body.classList.add('overflow-hidden');
            const theme_cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
            if (theme_cart && theme_cart.classList.contains('is-empty')) theme_cart.classList.remove('is-empty');
            theme_cart.classList.add('active');
            })
            .catch((e) => {
            console.error('Error updating cart sections:', e);
        });
    },
    error: function (response) {
        console.log(response.responseJSON.description);
    }
    });
})

document.addEventListener("click",function (e) {
    const btn = e.target.closest("button.unicorn_button.items_remove__qS11A.unicorn_cart_cell_remove");
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    const rowIndex = btn.closest('tr').rowIndex;
    let get_key;
    const currentItem =
    unicornCartData.items.length === 1
        ? unicornCartData.items[0]
        : unicornCartData.items[rowIndex];
    console.log(rowIndex,currentItem)
    let checked = currentItem?.properties?.some((p) => p[0] === "__smart_discount_flow_properties");
    get_key = currentItem?.properties?.find((p) => p[0] === "_bundle_id")?.[1];
    const updates = {};
    if (checked) {
    unicornCartData.items.forEach((item) => {
        const id = item?.properties?.find((p) => p[0] === "_bundle_id")?.[1];
        if (id === get_key && item.key) {
        updates[item.key] = 0;
        }
    });
    console.log(get_key, 'get_key','else');
    }else {            
    const item = unicornCartData.items[rowIndex-1];
    console.log(item, 'item','ifff');        
    if (item?.key) {
        updates[item.key] = 0;
    }
    }
    $.ajax({
        type: 'POST',
        url: '/cart/update.js',
        data: {
            updates: updates
        },
        dataType: 'json',
        success: function(res) {
            console.log('Removed from cart', res);
            unicornRefreshCart()
        },
        error: function(err) {
            console.error('Error removing items:', err);
        }
    });
    return false;
    },
 true
);


window.openCartDrawerss = function (id) {
    let isSubscription = $('.pvo-input-container.active');
    const product = (isSubscription.length == 0 ? withOut_subs : with_subs).find(item => item.variant_id == id);
    if (!product || !Array.isArray(product.image)) {
        console.log('Image array not found');
        return;
    }
    const image =  !((product.variant_title === '30 Tage Vorrat' || product.variant_title === '1 Dose') && product.has_selling_plan?.length === 0)
    ? [product.Gift_image, ...product.image]
    : product.image;
    $('.Gift_container .__gift').removeClass('active');
    $('.Gift_container .__gift').each(function(index, element) {
        if (image[index]) {
            $(this).find('.gifts__gift__image').attr('src', image[index]);
            $(this).addClass('active');
        }
        $(this).find('.gift__title').text(product.free_variant_title[index])
        $(this).find('.__gift__label__text').text(product.free_variant_price[index])
    });
    const $labels = $('fieldset.js.product-form__input.product-form__input--pill label');
    if (isSubscription.length > 0) {
        $('.Price_withOut_sellingPlan,.discount_variant_image,.Before_selling_discount').hide();
        $('.Price_with_sellingPlan,.option-title-rabatt,.After_selling_discount').show();
        if ($('body').hasClass('libido-third')) {
        $('.__gift[index="4"] .gift__title_unlocked').text('3+ Packungen')
        }else{
        $('.__gift[index="4"] .gift__title_unlocked').text('2+ Dosen')
        }

    } else {
        $('.Price_with_sellingPlan,.option-title-rabatt,.After_selling_discount').hide();
        $('.Price_withOut_sellingPlan,.discount_variant_image,.Before_selling_discount').show();
        //$('.__gift[index="4"] .gift__title_unlocked').text('2+ Dosen');
        if ($('body').hasClass('libido-third')) {
        $('.__gift[index="4"] .gift__title_unlocked').text('3+ Packungen')
        }else{
        $('.__gift[index="4"] .gift__title_unlocked').text('2+ Dosen')
        }
    }
    
    if(product.price===product.compare_at_price){
        $('button.newaddtocart .Compare__Priceee').hide()
    }else{
        $('button.newaddtocart .Compare__Priceee').show()
    }
    $('button.newaddtocart .Priceee').text(
        product.has_selling_plan.length > 0
            ? product.has_selling_plan
            : product.price
        );
    $('button.newaddtocart .Compare__Priceee').text(product.compare_at_price)

};

$(document).on("click", ".pvo-input-container", function(e) {
    $(this).toggleClass('active');
    let isSubscription = $('.pvo-input-container.active');
    const $labels = $('fieldset.js.product-form__input.product-form__input--pill label');
    if (isSubscription.length > 0) {
        $('.Price_withOut_sellingPlan,.discount_variant_image,.Before_selling_discount').hide();
        $('.Price_with_sellingPlan,.option-title-rabatt,.After_selling_discount').show();
        //$('.__gift[index="4"] .gift__title_unlocked').text('2+ Dosen');
        if ($('body').hasClass('libido-third')) {
        $('.__gift[index="4"] .gift__title_unlocked').text('3+ Packungen')
        }else{
        $('.__gift[index="4"] .gift__title_unlocked').text('2+ Dosen')
        }
        
    } else {
        $('.Price_with_sellingPlan,.option-title-rabatt,.After_selling_discount').hide();
        $('.Price_withOut_sellingPlan,.discount_variant_image,.Before_selling_discount').show();
        //$('.__gift[index="4"] .gift__title_unlocked').text('2+ Dosen')
        if ($('body').hasClass('libido-third')) {
        $('.__gift[index="4"] .gift__title_unlocked').text('3+ Packungen')
        }else{
        $('.__gift[index="4"] .gift__title_unlocked').text('2+ Dosen')
        }
    }
    let id = parseInt($('.product-form__input--pill input[type=radio]:checked').attr('var-id'))
    const product = (isSubscription.length == 0 ? withOut_subs : with_subs)
        .find(item => item.variant_id == id);
    if (!product || !Array.isArray(product.image)) {
        console.log('Image array not found');
        return;
    }
    const image =!((product.variant_title === '30 Tage Vorrat' || product.variant_title === '1 Dose') && product.has_selling_plan?.length === 0)
    ? [product.Gift_image, ...product.image]
    : product.image;
    $('.Gift_container .__gift').removeClass('active'); 
    $('.Gift_container .__gift').each(function(index, element) {
        if (image[index]) {
            $(this).find('.gifts__gift__image').attr('src', image[index]);
            $(this).addClass('active');
        }
        $(this).find('.gift__title').text(product.free_variant_title[index])
        $(this).find('.__gift__label__text').text(product.free_variant_price[index])
    });

    if(product.price===product.compare_at_price){
        $('button.newaddtocart .Compare__Priceee').hide()
    }else{
        $('button.newaddtocart .Compare__Priceee').show()
    }
    $('button.newaddtocart .Priceee').text(
        product.has_selling_plan.length > 0
            ? product.has_selling_plan
            : product.price
        );
    $('button.newaddtocart .Compare__Priceee').text(product.compare_at_price)
});


$(document).ready(function() {
  const $lastRadio = $('fieldset.js.product-form__input.product-form__input--pill input[type=radio]').last();
  $lastRadio.prop('checked', true).trigger('change');
  $('.pvo-input-container').trigger('click');
});



